var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:{ 'has-fixed-navbar':  _vm.hasFixedNavbar }},[(_vm.showLargeNavbar)?_c('large-navbar',{attrs:{"logo":_vm.logo,"fixed":_vm.hasFixedNavbar}}):_c('small-navbar',{attrs:{"logo":_vm.logo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }